import React, { Component } from 'react'
//import { Route } from 'react-router-dom'
//import StudentReport from './reports/StudentReport'
import '../styles/GlobalStyle.css'
import PacingGuideAssessment from '../teacher/pacingguide/PacingGuideAssessment'
//import { firebase, db } from '../firebase/Firebase'
import { getQueryStringParam } from '../Util'
//import ColType from '../Types'
import { Layout } from 'antd'
import CustomFooter from '../login/CustomFooter'
const Content = Layout.Content
const moment = require('moment')

class StudentAssessment extends Component {
    state = {
        assessmentId: '',
        // Cache the last valid quiz data to prevent unmounting during transitions
        cachedQuizData: null,
        cachedQuizSource: null // track where it came from: 'assessment' or 'completed'
    }

    componentDidMount() {
        document.title = 'My Quiz - Dot It'
        let assessmentId = getQueryStringParam('quiz')
        this.setState({
            assessmentId: assessmentId
        })
    }

    componentDidUpdate(prevProps, prevState) {
        // Update cached quiz data when we get new valid data
        const currentQuizData = this.getCurrentQuizData();
        const currentSource = this.getCurrentQuizSource();

        if (currentQuizData && (currentQuizData !== this.state.cachedQuizData || currentSource !== this.state.cachedQuizSource)) {
            this.setState({
                cachedQuizData: currentQuizData,
                cachedQuizSource: currentSource
            });
        }
    }

    getCurrentQuizData = () => {
        const { studentBaseProps } = this.props;
        const { assessmentId } = this.state;

        if (studentBaseProps?.assessmentsDict?.[assessmentId]) {
            return studentBaseProps.assessmentsDict[assessmentId];
        }

        if (studentBaseProps?.completedAssessmentsDict?.[assessmentId]) {
            return studentBaseProps.completedAssessmentsDict[assessmentId];
        }

        return null;
    }

    getCurrentQuizSource = () => {
        const { studentBaseProps } = this.props;
        const { assessmentId } = this.state;

        if (studentBaseProps?.assessmentsDict?.[assessmentId]) {
            return 'assessment';
        }

        if (studentBaseProps?.completedAssessmentsDict?.[assessmentId]) {
            return 'completed';
        }

        return null;
    }

    render() {
        // make sure serverMoment has loaded
        const inTestingTimeRange = this.props.studentBaseProps &&
            this.props.studentBaseProps.inTestingTimeRange &&
            this.props.studentBaseProps.serverMoment
        let isAssessment = this.props.studentBaseProps &&
            this.props.studentBaseProps.assessmentsDict &&
            this.props.studentBaseProps.assessmentsDict.hasOwnProperty(this.state.assessmentId) &&
            this.props.studentBaseProps.assessmentsDict[this.state.assessmentId]

        let isCompletedAssessment = this.props.studentBaseProps &&
            this.props.studentBaseProps.completedAssessmentsDict &&
            this.props.studentBaseProps.completedAssessmentsDict.hasOwnProperty(this.state.assessmentId) &&
            this.props.studentBaseProps.completedAssessmentsDict[this.state.assessmentId]

        // Use current quiz data if available, otherwise use cached data
        const currentQuizData = this.getCurrentQuizData();
        const quizData = currentQuizData || this.state.cachedQuizData;
        const quizSource = currentQuizData ? this.getCurrentQuizSource() : this.state.cachedQuizSource;

        // Use the cached source to determine status during transitions
        const effectiveIsAssessment = quizSource === 'assessment';
        const effectiveIsCompletedAssessment = quizSource === 'completed';

        let assessment = quizData;

        let testingTimeIsOver = false;
        let testingIsOpen = true;
        let canViewResults = false;
        let canViewTimeStamp = null;
        let assessmentCategory = '';
        // default to close testing if a week has passed since the assessment was created
        if (assessment &&
            assessment.hasOwnProperty('timeStamp') &&
            assessment.timeStamp &&
            assessment.timeStamp.hasOwnProperty('seconds')) {
            let assessmentMoment = moment.utc(assessment.timeStamp.seconds * 1000)
            let assessmentMomentEnd = assessmentMoment.clone().add(1, 'week')
            if (this.props.studentBaseProps && this.props.studentBaseProps.serverMoment) {
                if (this.props.studentBaseProps.serverMoment.isAfter(assessmentMomentEnd)) {
                    testingTimeIsOver = true
                }
            }
        }
        // but an existing isOpen property overrides that default
        if (assessment && assessment.hasOwnProperty('isOpen')) {
            testingIsOpen = assessment.isOpen
        }

        if (assessment) {
            assessmentCategory = assessment.quiz.assessmentCategory
            if (assessment.hasOwnProperty('quiz') &&
                assessment.quiz &&
                assessment.quiz.hasOwnProperty('assessmentTitle') &&
                assessment.quiz.assessmentTitle) {
                if (assessment.quiz.assessmentTitle.toLowerCase().includes('common assessment')) {
                    assessmentCategory = 'common_assessment'
                } else if (assessment.quiz.assessmentTitle.toLowerCase().includes('benchmark')) {
                    assessmentCategory = 'benchmark'
                } else if (assessment.quiz.assessmentTitle.toLowerCase().includes('quiz')) {
                    assessmentCategory = 'quiz'
                }
            }
            let completedTimeStamp = null;
            if (assessment.hasOwnProperty('completedQuizTimeStamp') &&
                assessment.completedQuizTimeStamp &&
                assessment.completedQuizTimeStamp.hasOwnProperty('seconds')) {
                completedTimeStamp = moment.utc(assessment.completedQuizTimeStamp.seconds * 1000);
            } else if (assessment.hasOwnProperty('timeStamp') &&
                assessment.timeStamp &&
                assessment.timeStamp.hasOwnProperty('seconds')) {
                // completedQuizTimeStamp added later, when it was assigned is the fallback
                completedTimeStamp = moment.utc(assessment.timeStamp.seconds * 1000);
            }
            if (assessmentCategory === 'quiz') {
                if (completedTimeStamp &&
                    this.props.studentBaseProps &&
                    this.props.studentBaseProps.serverMoment) {
                    canViewTimeStamp = completedTimeStamp.clone().add(3, 'days')
                    if (this.props.studentBaseProps.serverMoment.isAfter(canViewTimeStamp)) {
                        canViewResults = true
                    }
                }
            } else if (assessmentCategory === 'common_assessment') {
                // can view after 5 days
                if (completedTimeStamp &&
                    this.props.studentBaseProps &&
                    this.props.studentBaseProps.serverMoment) {
                    canViewTimeStamp = completedTimeStamp.clone().add(5, 'days')
                    if (this.props.studentBaseProps.serverMoment.isAfter(canViewTimeStamp)) {
                        canViewResults = true
                    }
                }
            } else if (assessmentCategory === 'benchmark') {
                if (completedTimeStamp &&
                    this.props.studentBaseProps &&
                    this.props.studentBaseProps.serverMoment) {
                    canViewTimeStamp = completedTimeStamp.clone().add(10, 'days')
                    if (this.props.studentBaseProps.serverMoment.isAfter(canViewTimeStamp)) {
                        canViewResults = true
                    }
                }
            }
        }

        // Show the component if we have any quiz data OR if we're in a valid assessment state
        const shouldShowAssessment = quizData &&
            ((effectiveIsAssessment && testingIsOpen && inTestingTimeRange) || (effectiveIsCompletedAssessment && canViewResults));

        // Determine container class
        let containerClassName = ' '
        if (effectiveIsAssessment && (!testingIsOpen || !inTestingTimeRange)) {
            containerClassName = ' sub-menu-width pl-2 pr-2'
        } else if (effectiveIsCompletedAssessment && !canViewResults) {
            containerClassName = ' w-750'
        }

        // Check if we've never had any quiz data
        const neverHadQuizData = !quizData && !this.state.cachedQuizData;

        return (
            <div>
                <Layout className="content layout-header-mt">
                    <Layout className="mt-0">
                        <Content className="mt-0">
                            <div className={"m-lr-auto mt-4 mb-100 background-fully-transparent" + containerClassName}>
                                {!inTestingTimeRange && effectiveIsAssessment ?
                                    <div className='p-4 br-20 text-center' style={{ background: '#b3e9ff' }}>
                                        <img src='/no-assessments.png' alt='no assessments' width={250} />
                                        <div className='font-24'>The testing window is Monday-Friday from 7:30am to 4:00pm.<br />
                                            You can continue testing then!</div>
                                    </div>
                                    : ''}

                                {effectiveIsAssessment && !testingIsOpen && inTestingTimeRange ?
                                    <div className='p-4 br-4 text-center' style={{ background: '#b3e9ff' }}>
                                        <img src='/no-assessments.png' alt='no assessments' width={250} />
                                        <div className='font-30'>Testing is currently closed.</div>
                                    </div>
                                    : ''}

                                {quizData && shouldShowAssessment ?
                                    <PacingGuideAssessment
                                        key={this.state.assessmentId} // Keep the same key to prevent remounting
                                        quiz={quizData}
                                        studentSettings={this.props.studentBaseProps &&
                                            this.props.studentBaseProps.hasOwnProperty('studentSettings') &&
                                            this.props.studentBaseProps.studentSettings ?
                                            this.props.studentBaseProps.studentSettings :
                                            null
                                        }
                                    />
                                    : ''}

                                {effectiveIsCompletedAssessment && !canViewResults && canViewTimeStamp ?
                                    <div className='p-4 br-20 text-center' style={{ background: '#b3e9ff' }}>
                                        <img src='/no-assessments.png' alt='no assessments' width={250} />
                                        <div className='font-24'>You will be able to view the question results on {canViewTimeStamp.format("MM/DD/YYYY")}.</div>
                                    </div>
                                    : ''}

                                {neverHadQuizData ?
                                    <div className='p-4 br-20 text-center' style={{ background: '#b3e9ff' }}>
                                        <img src='/no-assessments.png' alt='no assessments' width={250} />
                                        <div className='font-30'>This assessment was not found.</div>
                                    </div>
                                    : ''}
                            </div>
                        </Content>
                    </Layout>
                </Layout>
                <CustomFooter />
            </div>
        )
    }
}

export default StudentAssessment